"use client";
import React from "react";
import { InputField } from "@/forms/InputField";
import { useFormContext } from "react-hook-form";
import { isValidEmail } from "@cappelendamm/e-commerce-services";

type EmailFieldProps = {
  isDisabled?: boolean;
};

export type EmailFieldForm = {
  email: string;
};

export const EmailField = ({ isDisabled }: EmailFieldProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<EmailFieldForm>();

  return (
    <InputField
      name="email"
      label="E-postadresse"
      register={register}
      error={errors.email}
      requiredMessage="Du må skrive inn en e-postadresse"
      validate={isValidEmail}
      disabled={isDisabled}
      sensitive
    />
  );
};
